import { render, staticRenderFns } from "./M2hBioAgeWidget.vue?vue&type=template&id=4a30d8f8&scoped=true&"
import script from "./M2hBioAgeWidget.vue?vue&type=script&lang=js&"
export * from "./M2hBioAgeWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a30d8f8",
  null
  
)

export default component.exports